import { AppBarProps } from '@mui/material/AppBar';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { HeaderRefreshButton } from '@shiftnex/framework/src/components/organisms/navigation';

export const RefreshButton = ({ ...props }: AppBarProps) => {
  const { lastUpdate: lastRefreshUpdate, callRefresh } = useRefreshSyncStore();

  const handleRefresh = () => {
    callRefresh();
  };

  return (
    <>
      <HeaderRefreshButton localizationSubset="header" onRefresh={handleRefresh} lastUpdate={lastRefreshUpdate} />
    </>
  );
};
